exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-container[data-v-afb281ea]{position:relative;width:100px}.image-container .image[data-v-afb281ea]{width:100px;height:100px;border:1px solid #b4bccc}.image-container .del-button[data-v-afb281ea]{position:absolute;bottom:10px;left:85px}", ""]);

// exports
